var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg9(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.11035C6.22251 2.11035 2.6711 3.58143 0 6.25252L1.01694 7.26946C3.41641 4.86999 6.60665 3.54854 10 3.54854C13.3934 3.54854 16.5836 4.86999 18.9831 7.26946L20 6.25252C17.329 3.58143 13.7775 2.11035 10 2.11035Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71185 8.96437L3.72879 9.98131C5.40389 8.3062 7.63102 7.3837 10 7.3837C12.369 7.3837 14.5961 8.3062 16.2712 9.98131L17.2882 8.96437C15.3414 7.01764 12.7531 5.94552 10 5.94552C7.24688 5.94552 4.65858 7.01764 2.71185 8.96437Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42374 11.6763L6.44068 12.6932C8.40328 10.7307 11.5968 10.7307 13.5594 12.6932L14.5763 11.6763C12.0529 9.15286 7.94708 9.15286 5.42374 11.6763Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.6158C8.54614 13.6158 7.36332 14.7987 7.36332 16.2525C7.36332 17.7064 8.54614 18.8892 10 18.8892C11.4539 18.8892 12.6367 17.7064 12.6367 16.2525C12.6367 14.7987 11.4539 13.6158 10 13.6158ZM10 17.451C9.33915 17.451 8.80151 16.9134 8.80151 16.2525C8.80151 15.5917 9.33915 15.054 10 15.054C10.6608 15.054 11.1985 15.5917 11.1985 16.2525C11.1985 16.9134 10.6608 17.451 10 17.451Z",
    fill: "#222222"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.95e89fa68be3b559a63a591cfcd3cede.svg";
export { ForwardRef as ReactComponent };